export const LOADING_COURSE = "LOADING_COURSE";
export const SAVE_LOADING_COURSE = "SAVE_LOADING_COURSE";
export const GET_COURSE = "GET_COURSE";
export const FORM_FAIL = "FORM_FAIL";
export const COURSE_FAIL = "COURSE_FAIL";
export const LOADING_COURSE_BY_ID = "LOADING_COURSE_BY_ID";
export const GET_COURSE_BY_ID = "GET_COURSE_BY_ID";